// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__36Kxq","question":"Question_question__1BC7D","description":"Question_description__WqoDZ"};